import {OutboundLink} from "gatsby-plugin-google-analytics";
import {GatsbyImage} from "gatsby-plugin-image";
import React from "react";

import {LogoURL, OrganizationName} from "../../../lib/constants";
import "./PostCard.scss";

const PostCard = ({data}) => {
  return (
    <article itemScope itemType='http://schema.org/BlogPosting'>
      <div
        hidden
        itemProp='publisher'
        itemScope=''
        itemType='https://schema.org/Organization'
      >
        <meta itemProp='name' content={OrganizationName} />
        <div
          itemProp='logo'
          itemScope=''
          itemType='https://schema.org/ImageObject'
        >
          <meta itemProp='url' content={LogoURL} />
        </div>
      </div>
      <time itemProp='datePublished' dateTime={data.published_at} />
      <time itemProp='dateModified' dateTime={data.updated_at} />
      <meta
        itemScope=''
        itemProp='mainEntityOfPage'
        itemType='https://schema.org/WebPage'
        itemID={`https://getmason.io/blog/post/${data.slug}/`}
      />
      <meta
        itemScope=''
        itemProp='url'
        content={`https://getmason.io/blog/post/${data.slug}/`}
        itemID={`https://getmason.io/blog/post/${data.slug}/`}
      />
      <div className='md:p-2 w-full mb-4 md:mb-0 box-border'>
        <div className='post-card-wrap flex flex-col justify-between rounded-lg overflow-hidden shadow-md hover:shadow-lg'>
          <OutboundLink
            href={`/blog/post/${data.slug}`}
            className='post-display h-2/5'
          >
            <figure
              itemProp='image'
              itemScope=''
              itemType='http://schema.org/ImageObject'
            >
              <GatsbyImage
                image={data.localImage.childImageSharp.gatsbyImageData}
                alt={`${data.slug}`}
              />
              {/* <img src={data.feature_image} alt="post-image" /> */}
              <meta
                itemProp='url'
                content={
                  data.og_image ??
                  "https://media.kubric.io/api/assetlib/93f3ac48-6d81-4af3-b78a-5512fcd4affa.png"
                }
              />
            </figure>
          </OutboundLink>
          <div className='post-card-content flex flex-col flex-grow justify-between p-4'>
            <div className='post-top'>
              {data.tags
                .filter(({name}) => !name.startsWith("#"))
                .map((tag) => (
                  <OutboundLink
                    href={`/blog/tag/${tag.slug}`}
                    className='post-tag my-4'
                  >
                    {tag.name}
                  </OutboundLink>
                ))}
              <OutboundLink href={`/blog/post/${data.slug}`}>
                <h3 className='medium' itemProp='headline'>
                  {data.title}
                </h3>
              </OutboundLink>
            </div>
            <div className='post-bottom'>
              {data.authors.map((author) => (
                <div
                  className='f-author  my-4 flex flex-row items-center'
                  itemProp='author'
                  itemScope=''
                  itemType='http://schema.org/Person'
                >
                  <img
                    src={author.profile_image}
                    className='w-8 h-8 rounded-full'
                    alt={`${author.name}`}
                  />
                  <div className='authour-name ml-2' itemProp='name'>
                    {author.name}
                  </div>
                  <meta itemProp='url' content={author.url} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </article>
  );
};

export default PostCard;
